import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "./LandingPage.module.css";
import { Box, Typography } from "@mui/material";
import { Logo } from "./assets/SvgImage";
import { useBreakpoints } from "./ResponsiveBreapoints";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const { IsXS, IsSM } = useBreakpoints();
  const navigate = useNavigate();
  const handleLogoClick = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };
  return (
    <Grid container className={styles.headerContainer} justifyContent="center">
      <Grid size={{ xs: 12, sm: 11, md: 11, lg: 8, xl: 7 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid>
            <div onClick={handleLogoClick} style={{ cursor: "pointer" }}>
              <Logo
                width={IsXS || IsSM ? "200px" : "300px"}
                height={IsXS || IsSM ? "80px" : "120px"}
                color="#ffffff"
              />
            </div>
          </Grid>
          <Grid>
            <Box sx={{ display: 'flex', gap: IsXS || IsSM ? 2 : 4 }}>
              <Typography
                className={styles.mainComponentMenu}
                onClick={() => navigate("/")}
                sx={{ fontSize: IsXS || IsSM ? '12px !important' : '16px !important' }}
              >
                HOME
              </Typography>
              <Typography
                className={styles.mainComponentMenu}
                onClick={() => navigate("/blogs")}
                sx={{ fontSize: IsXS || IsSM ? '12px !important' : '16px !important' }}
              >
                BLOGS
              </Typography>
              <Typography
                className={styles.mainComponentMenu}
                onClick={() => navigate("/contact-us")}
                sx={{ fontSize: IsXS || IsSM ? '12px !important' : '16px !important' }}
              >
                CONTACT US
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Header;
